import {useEffect} from 'react';
import {mergeAll} from 'rxjs/operators';
import useSocket from '../../../hooks/use-socket';

let unsubscribe$ = null;

const useMapAlarm = (state, dispatch, instance) => {
  const {positions} = useSocket();

  const {instance: map, deviceMap, initializedPositions} = state;

  useEffect(() => {
    return () => {
      unsubscribe$ && unsubscribe$.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (map && deviceMap && initializedPositions) {
      for (const [deviceId, {currentPosition}] of deviceMap) {
        if (currentPosition && currentPosition.attributes.alarm) {
          const {longitude, latitude} = currentPosition;
          map.addAlarmOverlay(deviceId, currentPosition.attributes.alarm, [
            longitude,
            latitude,
          ]);
        }

        map.instance.render();

        unsubscribe$ = positions
            .pipe(mergeAll())
            .subscribe(({deviceId, longitude, latitude, attributes}) => {
              const overlay = map.instance.getOverlayById(`alarm-${deviceId}`);
              if (attributes.alarm) {
                if (overlay) {
                  overlay.getElement().querySelector('.alarm-name').innerText =
                  attributes.alarm;
                  map.updateOverlayPosition(null, [longitude, latitude], overlay);
                } else {
                  map.addAlarmOverlay(deviceId, attributes.alarm, [
                    longitude,
                    latitude,
                  ]);
                }
              } else {
                if (overlay) map.removeOverlayById(`alarm-${deviceId}`);
              }
            });
      }
    }
  }, [map, deviceMap, initializedPositions]);

  return {};
};

export default useMapAlarm;
